import { render, staticRenderFns } from "./CommentBlock.vue?vue&type=template&id=f4f292b0&scoped=true"
import script from "./CommentBlock.vue?vue&type=script&lang=js"
export * from "./CommentBlock.vue?vue&type=script&lang=js"
import style0 from "./CommentBlock.vue?vue&type=style&index=0&id=f4f292b0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4f292b0",
  null
  
)

export default component.exports